<template>
    <EmployeeServiceReportApprovalHistory></EmployeeServiceReportApprovalHistory>
</template>
<script>
    import EmployeeServiceReportApprovalHistory from '@/components/EmployeeServiceReportApprovalHistory.vue'
    export default {
        name: 'employee-service-reports',
        components: {
            EmployeeServiceReportApprovalHistory
        }
    }
</script>